import {round} from "../../../services/MathFunctions";

export const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
export const COLORS = [
    '#7D6AC8', // purple
    '#69C9E2', // sky
    '#52C794', // green
    '#FFC480', // orange
    '#FF67A3', // pink
    '#FF6767', // red
    '#5276E0', // blue
    '#FFEB7F', // yellow
    '#BEB4E4', // lighter-purple
    '#A9BBEF', // lighter-blue
    '#AAE0EE', // lighter-sky
    '#B2E6CF', // lighter-green
    '#FFF3B2', // lighter-yellow
    '#FFDBB3', // lighter-orange
    '#FFB2D1', // lighter-pink
    '#FFB2B2'  // lighter-red
];

export default function statusDataToRadarChartJsData(statusData) {
    const groupedData = groupByParentTopic(statusData);

    return convertToRadarChartData(groupedData, statusData);
}

function groupByParentTopic(statusData) {
    return statusData.topics.map(groupTopic => {
        let sum = 0;
        let count = 0;

        groupTopic.topics.forEach(topic => {
            statusData.observations.forEach(observation => {
                if (observation.development_topic_id === topic.id && observation.assessment_value !== null) {
                    sum += observation.assessment_value;
                    count++;
                }
            });
        });

        return count > 0 ? sum / count : 0;
    });
}


function convertToRadarChartData(averages, data) {
    const labels = data.topics.map((groupTopic, index) => `⦿ ${groupTopic.text.split(" ")[0]}`);
    const datasets = [{
        data: Object.values(averages),
        fill: true,
        backgroundColor: 'rgba(125, 106, 200, 0.2)',
        borderColor: 'rgba(125, 106, 200, 1)',
        pointBackgroundColor: 'rgba(125, 106, 200, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: 'rgba(125, 106, 200, 0.2)',
        pointHoverBorderColor: 'rgba(125, 106, 200, 1)'
    }];
    const options = {
        scale: {
            ticks: {
                beginAtZero: true,
            },
        },
    };

    return {
        labels,
        datasets,
        options,
    };
}

export const calculateOverallAverage = (statusData) => {
    const groupedData = groupByParentTopic(statusData);
    let sum = 0;
    let count = 0;

    groupedData.forEach(value => {
        sum += value;
        count++;
    });

    return count > 0 ? round(sum / count, 1) : 0;
}
